module.exports = __webpack_public_path__ + "img/mq.b54b2a36.svg";